import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { promoItemsQueryOptions } from '@/features/promotion/api/promotion.api';
import { zonalManagersQueryOptions } from '@/features/users/api/users.api';
import { getFilterPanelProps, type UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { getDateFromToFilterFields, getZonalManagerFilterField } from '@/utils/filterFields';
import { BOOLEAN_FILTER_VALUE } from '@/utils/filters';
import { misCallersQueryOptions } from '../api/marketPromotion.api';
import { DONATION_ITEM_LOOKUP_PARAMS } from '../constants/marketPromotion.constants';
import {
  getDecisionStatusFilterField,
  getDonationItemsFilterField,
  getMisCallFilterFields,
} from '../utils/mpFilterFields';

interface DonationApprovalFilterPanelProps {
  filters: UrlSyncedFilters;
  isMisQueue?: boolean | undefined;
}

export function DonationApprovalFilterPanel({
  filters,
  isMisQueue = false,
}: DonationApprovalFilterPanelProps) {
  const { data: zonalManagers } = useQuery(zonalManagersQueryOptions());
  const { data: items } = useQuery(promoItemsQueryOptions(DONATION_ITEM_LOOKUP_PARAMS));
  const { data: callers } = useQuery({ ...misCallersQueryOptions(), enabled: isMisQueue });

  const isVerifiedPicked = filters.filterValues.isMisVerified === BOOLEAN_FILTER_VALUE.yes;

  return (
    <AdvancedFilterPanel
      fields={[
        ...getDateFromToFilterFields(),
        getDonationItemsFilterField(items?.data),
        getZonalManagerFilterField(zonalManagers, 'enteredBy'),
        getDecisionStatusFilterField(isMisQueue ? 'Approval Status' : undefined),
        ...(isMisQueue ? getMisCallFilterFields(callers, isVerifiedPicked) : []),
      ]}
      {...getFilterPanelProps(filters)}
    />
  );
}
